import { atom } from "jotai";

import { JoinNewClubStepState } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const proceedToJoinNewClubStepAtom = atom(null, (get, set) => {
  const track = get(VerificationModalTrackEventAtom);
  const nextStep: JoinNewClubStepState = {
    step: "JoinNewClub",
    backStep: null,
  };
  set(VerificationModalStepStateAtom, nextStep);
  track?.("AuthModal.JoinNewClubStep", nextStep);
});
